package org.zq.astrock_ai.network

import io.ktor.client.HttpClient

actual fun createAiHttpClient(): HttpClient = createPlatformHttpClient()
